module.exports = __webpack_public_path__ + "img/symbol_19_free.f1f7f989.png";